import { createStyles, makeStyles } from '@bamboohr/fabric';

export const accessLevelActionStyles = makeStyles(() => {
	return createStyles({
		historyButton: {
			marginRight: '12px',
		},
	});
});
